module.exports = __webpack_public_path__ + "img/state_22.0a869ecc.jpg";